import styled from "styled-components";
import { FLEX } from "styles/flex";
import { Text } from "components/atoms/text/Text";
import InfoBubble from "components/blocks/bubble/InfoBubble";
import * as mediaQuery from "components/MediaQuery";
import { ReactComponent as InfoIcon } from "assets/icons/info.svg";
import { WithTooltip } from "components/blocks/WithTooltip";
import { COLORS } from "styles/colors";

type CheckIncludeProps = {
  isChecked?: boolean;
  onChange?: (checked: boolean) => void;
  label?: string;
  isCVV?: boolean;
};

//BUG [RND-397] CVV content add
function CheckInclude({
  isChecked,
  onChange,
  label,
  isCVV,
}: CheckIncludeProps): JSX.Element {
  const isDesktop = mediaQuery.useIsDesktop();
  return (
    <Container>
      <input
        type="checkbox"
        onChange={(e) => {
          if (onChange) {
            onChange(e.currentTarget.checked);
          }
        }}
        data-testid="blocks-subheader-sub-input-change"
      />

      <Text bold>{label}</Text>
      {isDesktop && (
        <WithTooltip
          tooltip={
            isCVV === undefined ? (
              <BubbleContents>
                This option allows you to see alert rules for all of the
                accounts that operate under
                <br /> the one you've logged into. This is especially helpful
                for channel partners who want
                <br /> to see all of their customer's alerts.
              </BubbleContents>
            ) : (
              <BubbleContents>
                Using Artificial Intelligence (AI), CVV monitors the image
                quality of your cameras and alerts you immediately of any
                deterioration
                <br /> such as blurriness, spider webs, dust, paint on the
                enclosure or a change of scene. You can filter the view on this
                page to only
                <br /> display cameras and references with CVV by toggling the
                checkmark next to the bold text that says "Camera View
                Verification."
              </BubbleContents>
            )
          }
        >
          <InfoButton>
            <InfoIcon />
          </InfoButton>
        </WithTooltip>
      )}
    </Container>
  );
}

const Container = styled.label`
  ${FLEX.FlexStartCenter};
  gap: 6px;
  /* border: 1px solid blue; */
`;

const InfoButton = styled.button`
  ${FLEX.FlexCenterCenter};
  position: relative;
  width: 20px;
  height: 20px;
  color: ${({ theme }) => theme.COLORS.BUTTONS3};
  border-radius: 50%;
  overflow: hidden;
  &:before {
    content: "";
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 95%;
    height: 95%;
    background-color: ${COLORS.WHITE};
    border-radius: 50%;
  }
  svg {
    position: relative;
    width: 100%;
    height: 100%;
  }
  ${mediaQuery.isMobile} {
    width: 14px;
    height: 14px;
  }
`;

const BubbleContents = styled.p`
  text-align: left;
`;

export default CheckInclude;
